/* RAYZ lux layer: intro, reveals, magnetic hover, card tilt, scroll progress, header hide/show.
   Timings follow the house motion tokens: reveals 0.9-1.1s on expo/power4-out, word stagger 55ms,
   card stagger 75ms, hover 0.45s. Everything is skipped for reduced motion and touch where noted. */
(function () {
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const G = !!window.gsap && !reduce;

  /* ---------- intro (homepage, once per visit) ---------- */
  const tips = (() => { try { return JSON.parse(document.getElementById('RayzTips').textContent).filter(Boolean); } catch (e) { return []; } })();
  const pickTip = () => tips[Math.floor(Math.random() * tips.length)] || '';
  window.RayzTip = pickTip;
  const intro = document.querySelector('.rz-intro');
  if (intro) {
    if (!html.classList.contains('rz-intro-on')) intro.remove();
    else {
      try { sessionStorage.setItem('rz-intro', '1'); } catch (e) {}
      const tipEl = intro.querySelector('[data-rz-intro-tip]');
      const tip = intro.dataset.tips === 'true' ? pickTip() : '';
      if (tip && tipEl) { tipEl.textContent = tip; intro.classList.add('has-tip'); }
      let ended = false;
      const done = () => { if (ended) return; ended = true; html.classList.add('rz-intro-out'); setTimeout(() => { html.classList.remove('rz-intro-on', 'rz-intro-out', 'rz-intro-play'); intro.remove(); }, 1100); };
      requestAnimationFrame(() => html.classList.add('rz-intro-play'));
      setTimeout(done, tip ? Math.min(4200, 2000 + tip.length * 22) : 1500);
      intro.addEventListener('pointerdown', done); addEventListener('keydown', done, { once: true });
    }
  }
  // a fresh tip each time the bag opens
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-rz-cart-open]')) return;
    setTimeout(() => document.querySelectorAll('[data-rz-tip]').forEach((t) => { const x = pickTip(); if (x) { t.textContent = x; t.hidden = false; } }), 60);
  });
  document.addEventListener('rz:cart-rendered', () => document.querySelectorAll('[data-rz-tip]').forEach((t) => { if (!t.textContent) { const x = pickTip(); if (x) { t.textContent = x; t.hidden = false; } } }));

  /* ---------- reveals ---------- */
  function splitWords(el) {
    if (el.dataset.rzSplit) return;
    el.dataset.rzSplit = '1';
    let i = 0;
    (function walk(node) {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const fr = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((t) => {
            if (!t) return;
            if (/^\s+$/.test(t)) { fr.appendChild(document.createTextNode(t)); return; }
            const m = document.createElement('span'); m.className = 'rz-wm';
            const w = document.createElement('span'); w.textContent = t; w.style.setProperty('--wi', i++);
            m.appendChild(w); fr.appendChild(m);
          });
          n.replaceWith(fr);
        } else if (n.nodeType === 1 && !n.matches('br')) walk(n);
      });
    })(el);
  }
  const rio = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    rio.unobserve(e.target);
    e.target.classList.add('is-in');
  }), { rootMargin: '0px 0px -16% 0px' });
  function reveals(root) {
    if (reduce) return;
    root.querySelectorAll('[data-rz-words]').forEach(splitWords);
    root.querySelectorAll('[data-rz-reveal-group]').forEach((g) => g.querySelectorAll('[data-rz-reveal-item]').forEach((it, i) => it.style.setProperty('--ri', i % 8)));
    root.querySelectorAll('[data-rz-reveal], [data-rz-words], [data-rz-reveal-group]').forEach((el) => rio.observe(el));
  }
  // Dawn's own page content gets the same entrance without markup changes
  function autoTag(root) {
    if (document.body.classList.contains('template-index')) return;
    root.querySelectorAll('.main-page-title, .article-template__title, .title-wrapper-with-link .title, .collection-hero__title, .blog .title, .template-search__header h1, .error-404 h1').forEach((el) => { if (!el.closest('.rz')) el.setAttribute('data-rz-words', ''); });
    root.querySelectorAll('.rte > *, .contact__fields').forEach((el) => { if (!el.closest('.rz') && !el.hasAttribute('data-rz-reveal')) el.setAttribute('data-rz-reveal', ''); });
  }
  autoTag(document);
  reveals(document);
  html.classList.add('rz-reveal-ready');
  document.addEventListener('shopify:section:load', (e) => { autoTag(e.target); reveals(e.target); });

  /* ---------- scroll progress + header hide/show ---------- */
  const bar = document.querySelector('.rz-progress i');
  let lastY = scrollY, hidden = false;
  function onFrame() {
    const y = scrollY, max = document.documentElement.scrollHeight - innerHeight;
    if (bar) bar.style.transform = `scaleX(${max > 0 ? Math.min(1, y / max) : 0})`;
    const hdr = document.querySelector('.rz-header-section');
    if (hdr && !html.classList.contains('rz-menu-open') && !document.querySelector('cart-drawer.is-open')) {
      const ap = document.querySelector('[data-rz="aperture"]');
      const inHero = ap && ap.getBoundingClientRect().bottom > 80;
      const dy = y - lastY;
      if (!inHero && y > 240 && dy > 4 && !hidden) { hidden = true; hdr.classList.add('is-tucked'); }
      else if ((dy < -4 || y < 240 || inHero) && hidden) { hidden = false; hdr.classList.remove('is-tucked'); }
    }
    lastY = y;
    requestAnimationFrame(onFrame);
  }
  if (!reduce) requestAnimationFrame(onFrame);
  else if (bar) addEventListener('scroll', () => { const max = document.documentElement.scrollHeight - innerHeight; bar.style.transform = `scaleX(${max > 0 ? scrollY / max : 0})`; }, { passive: true });

  if (!G || !fine) return;

  /* ---------- magnetic hover ---------- */
  function magnetic(root) {
    root.querySelectorAll('.rz-btn, .rz-menu-btn, .rz-lnk, #cart-icon-bubble, [data-rz-magnetic]').forEach((el) => {
      if (el.dataset.rzMag) return; el.dataset.rzMag = '1';
      const k = Number(el.dataset.rzMagnetic || 0.22);
      const xTo = gsap.quickTo(el, 'x', { duration: 0.45, ease: 'power3.out' }), yTo = gsap.quickTo(el, 'y', { duration: 0.45, ease: 'power3.out' });
      el.addEventListener('pointermove', (e) => { const r = el.getBoundingClientRect(); xTo((e.clientX - r.left - r.width / 2) * k); yTo((e.clientY - r.top - r.height / 2) * k); });
      el.addEventListener('pointerleave', () => { xTo(0); yTo(0); });
    });
  }
  /* ---------- card tilt (sets, product cards) ---------- */
  function tilt(root) {
    root.querySelectorAll('.rz-set, [data-rz-tilt]').forEach((el) => {
      if (el.dataset.rzTilt === '1') return; el.dataset.rzTilt = '1';
      const media = el.querySelector('.rz-set-ph, img') || el;
      gsap.set(media, { transformPerspective: 900, transformOrigin: '50% 50%' });
      const rx = gsap.quickTo(media, 'rotationX', { duration: 0.6, ease: 'power3.out' }), ry = gsap.quickTo(media, 'rotationY', { duration: 0.6, ease: 'power3.out' });
      el.addEventListener('pointermove', (e) => { const r = el.getBoundingClientRect(); ry(((e.clientX - r.left) / r.width - 0.5) * 6); rx(-((e.clientY - r.top) / r.height - 0.5) * 6); });
      el.addEventListener('pointerleave', () => { rx(0); ry(0); });
    });
  }
  /* ---------- hero type drifts a little with the pointer ---------- */
  function heroDepth(root) {
    const ap = root.querySelector('[data-rz="aperture"]');
    if (!ap || ap.dataset.rzDepth) return; ap.dataset.rzDepth = '1';
    const type = ap.querySelector('.rz-ap-type'), win = ap.querySelector('.rz-ap-fb');
    if (!type) return;
    const tx = gsap.quickTo(type, 'x', { duration: 1.1, ease: 'power3.out' }), ty = gsap.quickTo(type, 'y', { duration: 1.1, ease: 'power3.out' });
    const wx = win && gsap.quickTo(win, 'x', { duration: 1.4, ease: 'power3.out' }), wy = win && gsap.quickTo(win, 'y', { duration: 1.4, ease: 'power3.out' });
    ap.addEventListener('pointermove', (e) => { const x = e.clientX / innerWidth - 0.5, y = e.clientY / innerHeight - 0.5; tx(x * -18); ty(y * -10); if (wx) { wx(x * 14); wy(y * 10); } });
    ap.addEventListener('pointerleave', () => { tx(0); ty(0); if (wx) { wx(0); wy(0); } });
  }
  const all = (root) => { magnetic(root); tilt(root); heroDepth(root); };
  all(document);
  document.addEventListener('shopify:section:load', (e) => all(e.target));
})();
